import intl from 'react-intl-universal'

import { upgrade as labelsUpgrade } from '../settings/model/labels.js'

function kickerController(storyService, settingsService, toastr) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const vm = this
  vm.labels = {} // labels model
  vm.labelsCfg = null // org configured labels

  vm.intl = intl

  // matches existing story labels to ones in org settings
  // or ignores them, then packages labels and their various
  // options in a nice viewmodel
  const assemble = (labelsObj, labelCfg) => {
    const labelsModel = []
    if (!(labelCfg.types && Object.keys(labelCfg.types).length)) {
      toastr.warning(intl.get('kicker.assemble.warning'))
      return []
    }
    Object.entries(labelCfg.types).forEach(([key, labelType]) => {
      // for each org label type
      const savedLabel = labelsObj[key] || false // grab saved label, if there is one
      const match = (labelType.labels || []).find(
        (el) => el.text === savedLabel.text
      ) // try to match it against an existing label
      labelsModel.push({
        // for each label push a model with:
        key, // the labeltype key
        isFreeEntry: labelType.isFreeEntry, // whether the label is free entry
        freeEntryText:
          (labelType.isFreeEntry && savedLabel && savedLabel.text) || '', // the free entry text, if it was saved already
        options: labelType.labels, // a list of selectable labels
        display: key.replace(/_/g, ' '), // the display text of the label type
        value: (!labelType.isFreeEntry && match) || null, // reference to configured entry (for dropdown binding)
      })
    })
    return labelsModel.sort((a, b) =>
      a.key > b.key ? 1 : b.key > a.key ? -1 : 0
    )
  }

  const matchOrMakeLabel = (entry, existing = []) => {
    const text = entry.freeEntryText || (entry.value && entry.value.text)
    const match = (existing || []).find((el) => el.text === text)
    if (entry.freeEntryText && !match) {
      return {
        text: entry.freeEntryText,
        display: true,
      }
    }
    return match
  }

  const extract = (labelsModel, labelCfg) => {
    const labelsObj = {}
    labelsModel.forEach((entry) => {
      const labelTypeCfg = labelCfg.types[entry.key]
      if (!labelTypeCfg) {
        return
      }
      const extracted = matchOrMakeLabel(entry, labelTypeCfg.labels)
      if (extracted) {
        labelsObj[entry.key] = extracted
      }
    })
    return labelsObj
  }

  // returns promise after capturing live story object
  // and locally binding story.label
  const loadStoryLabels = () => {
    return storyService.getStory().then((story) => {
      vm.story = story
    })
  }

  // returns promise resolved with labels obj of org settings
  const loadFromSettings = () => {
    return settingsService.fetchCompanySettings('org').then((resp) => {
      return labelsUpgrade(resp.data.labels)
    })
  }

  vm.update = (setIsDirtyFlag) => {
    if (!vm.labelsCfg) {
      return
    }

    vm.story.label = extract(vm.labels, vm.labelsCfg)

    if (setIsDirtyFlag) {
      storyService.isDirty(true)
    }
  }

  vm.$onInit = () => {
    loadStoryLabels()
      .then(loadFromSettings)
      .then((orgLabels) => {
        vm.labelsCfg = orgLabels
        vm.labels = assemble(vm.story.label || {}, vm.labelsCfg)
        vm.update()
      })
  }
}

export default ['storyService', 'settingsService', 'toastr', kickerController]
